import React, { useState, useContext } from 'react';
import AuthContext from '../../context/AuthProvider';
import '../../index.css';
// assets
import Logo from '../../assets/logo.svg';
// components
import Loader from '../../helpers/Loader';

const Login = () => {
  // context
  const { signIn, loading } = useContext(AuthContext);
  // states
  const [pswd, setPswd] = useState('');

  // funcion que setea el estate de la contrasena
  const handleChangePswd = (value) => {
    setPswd(value);
  };
  // funcion para iniciar sesion
  const onSuccess = () => {
    signIn(pswd);
  };

  return (
    <div className="page-container">
      <div className="modal">
        <img src={Logo} className="logo" alt="logo" />
        <p className="login-text">Ingresa para cargar o descargar reportes</p>
        {/* <p className="text-input">Contraseña</p> */}
        <input
          className="input"
          type="password"
          placeholder="Contraseña..."
          value={pswd}
          onChange={(e) => handleChangePswd(e.target.value)}
        />
        <div className="actions">
          {loading ? (
            <Loader />
          ) : (
            <button
              className={
                pswd
                  ? 'btn-yummy btn-large btn-bg'
                  : ' btn-yummy btn-large btn-bg-disabled'
              }
              disabled={pswd ? false : true}
              onClick={onSuccess}>
              <p>INGRESAR</p>
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default Login;
